import { render, staticRenderFns } from "./CharacterReward.vue?vue&type=template&id=644498c4&"
import script from "./CharacterReward.vue?vue&type=script&lang=js&"
export * from "./CharacterReward.vue?vue&type=script&lang=js&"
import style0 from "./CharacterReward.vue?vue&type=style&index=0&id=644498c4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports